import {createSelector} from 'reselect';
import getBasketItems from './orderSummaryBasketItemsSelector';

export default createSelector(
  [getBasketItems],
  basketItems => !!basketItems
    ?.some(basketItem => basketItem.subscriptionBySku),
);
